import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../context/AppContext";

export const WELCOME_SEEN_KEY = "bl_welcome_seen";

// Shared email-capture flow for the Welcome / Abandon-cart modals.
export function useSubscribe(source, fallbackError) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    const clean = email.trim().toLowerCase();
    if (!clean.includes("@")) { toast.error("Please enter a valid email"); return; }
    setSubmitting(true);
    try {
      const r = await axios.post(`${API}/subscribers`, { email: clean, source });
      setResult(r.data);
      // Claiming a code from either popup means the welcome popup must never fire again.
      localStorage.setItem(WELCOME_SEEN_KEY, "1");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg || fallbackError);
    } finally { setSubmitting(false); }
  };

  const copyCode = () => {
    if (!result) return;
    navigator.clipboard.writeText(result.promo_code);
    toast.success(`${result.promo_code} copied`);
  };

  return { email, setEmail, submitting, result, submit, copyCode };
}
